/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { Column } from "../../../../common/commonComponents/mediaPreparationTable";

export const getColumns = (
    t: any,
    selectedBatchId: string | null,
    setSelectedBatchId: (id: string) => void,
    canStartGPT: boolean
  ): Column[] => {
    const columns: Column[] = [];
    if (canStartGPT) {
    columns.push({
      header: t("gptTest.tableColumns.select"),
      key: "select",
      render: (row) => (
        <td className="px-6 py-2 text-center">
          <div className="flex justify-center">
            <button
              type="button"
              onClick={() => setSelectedBatchId(row.id)}
              className={`w-5 h-5 rounded-full border flex items-center justify-center transition-all ${
                selectedBatchId === row.id
                  ? "bg-[#FF7043] border-[#FF7043]"
                  : "bg-white border-slate-300"
              }`}
            >
              {selectedBatchId === row.id && (
                <div className="w-2 h-1.5 rounded-full bg-white" />
              )}
            </button>
          </div>
        </td>
      ),
    });
  }

  columns.push(
  {
    header: t("gptTest.tableColumns.batch_no"),
    key: "batch_name",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="px-2.5 py-1.5 bg-slate-100 text-slate-900 font-mono font-medium text-[11px] uppercase tracking-wider rounded-md border border-slate-200 shadow-sm">
          {row.batchCode}
        </span>
      </td>
    ),
  },

  {
    header: t("gptTest.tableColumns.media_name"),
    key: "media_name",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <div className="flex flex-col">
          <span className="text-slate-800 text-sm tracking-tight">
            {row.name}
          </span>
        </div>
      </td>
    ),
  },

  {
    header: t("gptTest.tableColumns.manufacturer"),
    key: "manufacturer_name",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-slate-800 text-sm tracking-tight">
          {row.mf}
        </span>
      </td>
    ),
  },

  {
    header: t("gptTest.tableColumns.expiry_date"),
    key: "expiry_date",
    render: (row) => (
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-sm font-medium text-slate-700 tracking-tight">
          {row.expiry}
        </span>
      </td>
    ),
  },

  {
    header: t("gptTest.tableColumns.qa_status"),
    key: "qa_release_status",
    render: (row) => {
      const status = row.qaStatus;

      const style =
        status === "Approved" || status === "RELEASED"
          ? "text-red-700 bg-red-50 border-red-100"
          : status === "Quarantine"
          ? "text-purple-700 bg-purple-50 border-purple-100"
          : "text-amber-700 bg-amber-50 border-amber-100";

      return (
        <td className="px-6 py-2 whitespace-nowrap">
          <span className={`px-3 py-1 rounded-full text-[9px] font-medium uppercase tracking-widest border ${style}`}>
            {status}
          </span>
        </td>
      );
    },
  }
);
return columns;
};